export default __webpack_public_path__ + "static/media/97_desktop.ccd132dd.jpg";